const menuButton = document.querySelector('#menu-button')
const menu = document.querySelector('#site-navigation')
const subMenuButtons = document.querySelectorAll('.menu-item-has-children > .sub-nav-btn')

// Add index variables to each menu item for animation delay
document.querySelectorAll('#site-navigation ul > li').forEach((li, index) => {
  li.style.setProperty('--i', index + 1)
})

// === Toggle Main Menu ===
menuButton.addEventListener('click', (e) => {
  e.preventDefault()
  const isOpen = menu.classList.toggle('is-open')
  menuButton.classList.toggle('open-menu', isOpen)
  menuButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false')
  menu.setAttribute('aria-hidden', isOpen ? 'false' : 'true')
})

// === Submenu Toggle with Dynamic Height ===
for (const btn of subMenuButtons) {
  btn.addEventListener('click', (e) => {
    e.preventDefault()

    const parent = btn.closest('.menu-item-has-children')
    const submenu = parent.querySelector('.sub-menu')

    // Close other siblings at same level
    const siblings = [...parent.parentElement.children].filter(
      (sib) => sib !== parent && sib.classList.contains('menu-item-has-children')
    )
    for (const sib of siblings) {
      sib.classList.remove('submenu-open')
      const sibMenu = sib.querySelector('.sub-menu')
      sibMenu.style.maxHeight = null
    }

    // Toggle current submenu
    const isOpen = parent.classList.toggle('submenu-open')
    submenu.style.maxHeight = isOpen ? `${submenu.scrollHeight}px` : null
  })
}

// === Body scroll class ===
window.addEventListener(
  'scroll',
  () => {
    document.body.classList.toggle('has-scrolled', window.scrollY > 30)
  },
  { passive: true }
)

// === Reset on Desktop Resize ===
window.addEventListener('resize', () => {
  if (window.innerWidth > 769) {
    menu.classList.remove('is-open')
    menuButton.classList.remove('open-menu')
    menuButton.setAttribute('aria-expanded', 'false')
    menu.setAttribute('aria-hidden', 'true')
    for (const el of document.querySelectorAll('.submenu-open')) {
      el.classList.remove('submenu-open')
      const subMenu = el.querySelector('.sub-menu')
      subMenu.style.maxHeight = null
    }
  }
})
